export default "__VITE_ASSET__OpReub_2__"